import styled from 'styled-components'
import { UserGroup } from '../../../models/UserGroup'
import { User, UserAll, UserRole } from '../../../models/User'
import { useEffect, useRef, useState } from 'react'
import { axiosGet, axiosPost } from '../../Common/Axios'
import {
  BlueButton,
  GreenButton,
  OrangeButton,
  TomatoButton,
} from '../../Layout/CommonStyle'
import toast from 'react-hot-toast'
import { ApiResult } from '../../../models/Enums'
import Popup from '../../Popup/Popup'
import InstructorList from '../../Popup/InstructorList'
import Waiting from '../../Common/Waiting'

type Props = {
  group: UserGroup | undefined
  setGroup: (group: UserGroup | undefined) => void
  groups: UserGroup[]
  setGroups: (groups: UserGroup[]) => void
}

enum PasswordType {
  EQUAL_TO_USERID = 1,
  EQUAL_PASSWORD = 2,
}

function Main(props: Props) {
  const [instructor, setInstructor] = useState<UserAll | undefined>(undefined)
  const [students, setStudents] = useState<UserAll[]>([])
  const [waiting, setWaiting] = useState(false)

  //const saveAllRef = useRef<HTMLTextAreaElement>(null)

  const [createStudentCnt, setCreateStudentCnt] = useState<number>(
    props.group?.batchStudentCnt || 0
  )
  const [startId, setStartId] = useState<string>(
    props.group?.batchIdPrefix || ''
  )
  const [startIdNo, setStartIdNo] = useState<number>(
    props.group?.batchIdStartNo || 1
  )
  const [startName, setStartName] = useState<string>(
    props.group?.batchNamePrefix || ''
  )
  const [startNameNo, setStartNameNo] = useState<number>(
    props.group?.batchNameStartNo || 1
  )
  const [passwordType, setPasswordType] = useState<PasswordType>(
    props.group?.passwordType || PasswordType.EQUAL_TO_USERID
  )
  const [commonPassword, setCommonPassword] = useState<string>(
    props.group?.passwordStr || ''
  )
  const [classPassword1, setClassPassword1] = useState<string>(
    props.group?.classPassword1 || '2345'
  )
  const [classPassword2, setClassPassword2] = useState<string>(
    props.group?.classPassword2 || '3456'
  )

  // 처음 시작할때 학생계정을 만드는 모드인지 여부 (기존에 있는 학급을 일괄 삭제 생성해서는 안된다)
  const [isFirstInsertMode, setIsFirstInsertMode] = useState<boolean>(true)
  const [showSetting, setShowSetting] = useState<boolean>(false)

  const [instructors, setInstructors] = useState<UserAll[]>([])
  const [openInstructorList, setOpenInstructorList] = useState<boolean>(false)

  const getInstructors = async () => {
    // get_mentors는 user테이블의 userRole이 20(UserRole.MENTOR)인것만 가져온다
    const result = await axiosGet('/api/user/get_mentors')
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_mentors error', result.message)
    }
    setInstructors(result.data)
    console.log('result', result)
  }

  useEffect(() => {
    getInstructors()
  }, [])

  const loadUsers = async () => {
    if (props.group === undefined) {
      return
    }

    const result = await axiosGet('/api/user/group_user/' + props.group.id)
    if (result === '') {
      return
    }
    console.log('result', result)

    const _students = result.data['students'] as UserAll[]
    const _instructor = result.data['instructor'] as UserAll

    setInstructor(_instructor)
    setStudents(_students)

    setIsFirstInsertMode(_students.length === 0)
  }

  useEffect(() => {
    loadUsers()

    setCreateStudentCnt(props.group?.batchStudentCnt || 0)
    setStartId(props.group?.batchIdPrefix || '')
    setStartIdNo(props.group?.batchIdStartNo || 1)
    setStartName(props.group?.batchNamePrefix || '')
    setStartNameNo(props.group?.batchNameStartNo || 1)
    setPasswordType(props.group?.passwordType || PasswordType.EQUAL_TO_USERID)
    setCommonPassword(props.group?.passwordStr || '')
    setClassPassword1(props.group?.classPassword1 || '2345')
    setClassPassword2(props.group?.classPassword2 || '3456')
  }, [props.group])

  const applyUserId = () => {
    if (props.group === undefined) {
      return
    }

    const _students = [...students]
    const id: string = startId
    let idNo: number = startIdNo
    for (let i = 0; i < _students.length; i++) {
      const student = _students[i]
      student.userid = id + idNo.toString()
      idNo++
    }
    setStudents(_students)
  }

  const applyUsername = () => {
    if (props.group === undefined) {
      return
    }

    const _students = [...students]
    const name: string = startName
    let nameNo: number = startNameNo
    for (let i = 0; i < _students.length; i++) {
      const student = _students[i]
      student.username = name + nameNo.toString()
      nameNo++
    }
    setStudents(_students)
  }

  const applyPassword = () => {
    if (props.group === undefined) {
      return
    }

    const _students = [...students]
    const password = commonPassword
    for (let i = 0; i < _students.length; i++) {
      const student = _students[i]
      if (passwordType === PasswordType.EQUAL_TO_USERID) {
        student.plainPassword = student.userid
      } else {
        student.plainPassword = password
      }
    }
    setStudents(_students)
  }

  const createUser = () => {
    if (createStudentCnt < 1) {
      alert('생성할 학생 수를 입력해주세요.')
      return
    }

    const _students = [...students]

    if (createStudentCnt > _students.length) {
      // 추가 생성
      for (let i = _students.length; i < createStudentCnt; i++) {
        _students.push({
          id: 0,
          userid: '',
          username: '',
          email: '',
          password: '',
          profileImage: '',
          userRole: UserRole.MENTEE,
          groupId: props.group?.id || 0,
          enabled: true,
          setting: '{}',
          recentJobs: '[]',
          plainPassword: '',
          isUpdatePassword: false,
        })
      }
    } else {
      // 삭제
      _students.splice(createStudentCnt, _students.length - createStudentCnt)
    }

    setStudents(_students)
  }

  const addUser = () => {
    const _students = [...students]
    _students.push({
      id: 0,
      userid: '',
      username: '',
      email: '',
      password: '',
      profileImage: '',
      userRole: UserRole.MENTEE,
      groupId: props.group?.id || 0,
      enabled: true,
      setting: '{}',
      recentJobs: '[]',
      plainPassword: '',
      isUpdatePassword: false,
    })
    setStudents(_students)
  }

  const deleteStudent = (userid: string) => {
    const _students = students.filter((s) => s.userid !== userid)
    setStudents(_students)
  }

  // 수정모드에서 바꿘 아이디 비번 이름 적용
  const applyUser = async (userid: string) => {
    let user = students.find((s) => s.userid === userid)

    if (!user && instructor && instructor.userid === userid) {
      user = instructor
    }

    if (!user) {
      toast.error(`사용자 아이디를 찾을 수 없습니다. (${userid})`)
      return
    }

    // TODO: 적용 전송
    const result = await axiosPost('/api/user/update_userinfo', user)

    if (result.apiResult != ApiResult.SUCCESS) {
      toast.error('저장에 실패했습니다.')
      return
    }
    toast.success('저장했습니다.')
  }
  const onChangeStudentUserid = (
    e: React.FormEvent<HTMLInputElement>,
    studentIndex: number
  ) => {
    const userid = (e.target as HTMLInputElement).value
    setStudents(
      students.map((s, index) =>
        index === studentIndex ? { ...s, userid } : s
      )
    )
  }

  const onChangeStudentUsername = (
    e: React.FormEvent<HTMLInputElement>,
    studentIndex: number
  ) => {
    const username = (e.target as HTMLInputElement).value
    setStudents(
      students.map((s, index) =>
        index === studentIndex ? { ...s, username } : s
      )
    )
  }

  const onChangeStudentPassword = (
    e: React.FormEvent<HTMLInputElement>,
    studentIndex: number
  ) => {
    const plainPassword = (e.target as HTMLInputElement).value
    setStudents(
      students.map((s, index) =>
        index === studentIndex ? { ...s, plainPassword } : s
      )
    )
  }

  // 학생 전체 저장
  const handleSaveAll = async () => {
    if (props.group === undefined) {
      return
    }

    const _students = [...students]

    const result = await axiosPost('/api/user/create_user_all', _students)
    if (result.apiResult != ApiResult.SUCCESS) {
      toast.error('저장에 실패했습니다.')
      return
    } else {
      //toast.success('저장했습니다.')
    }

    const newGroup = {
      ...props.group,
      batchStudentCnt: createStudentCnt,
      batchIdPrefix: startId,
      batchIdStartNo: startIdNo,
      batchNamePrefix: startName,
      batchNameStartNo: startNameNo,
      passwordType: passwordType,
      passwordStr: commonPassword,
    } as UserGroup

    console.log('newGroup', newGroup)

    const result2 = await axiosPost('/api/user/update_group', newGroup)
    if (result2.apiResult != ApiResult.SUCCESS) {
      toast.error('저장에 실패했습니다.')
      return
    } else {
      toast.success('저장했습니다.')
    }

    props.setGroups(
      props.groups.map((g) => (g.id === newGroup.id ? newGroup : g))
    )
  }

  const onSelectInstructor = async (instructor: UserAll) => {
    console.log('instructor', instructor)
    setInstructor(instructor)
    setOpenInstructorList(false)

    const payload = {
      groupId: props.group?.id,
      instructorId: instructor.id,
    }
    const result = await axiosPost('/api/user/update_group_instructor', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      toast.error('강사 변경에 실패했습니다.')
      return
    }

    const newGroup = {
      ...props.group,
      instructorId: instructor.id,
    } as UserGroup

    props.setGroups(
      props.groups.map((g) => (g.id === newGroup.id ? newGroup : g))
    )

    console.log('setGroups', props.groups)
    toast.success('강사를 변경했습니다.')
  }

  const handleReset = async () => {
    if (props.group === undefined) {
      return
    }
    if (!confirm(`[${props.group.name}] 학급을 초기화 하시겠습니까?`)) {
      return
    }
    setWaiting(true)
    const result = await axiosPost('/api/user/reset_group', props.group?.id)
    if (result.apiResult !== ApiResult.SUCCESS) {
      toast.error('초기화에 실패했습니다.')
      setWaiting(false)
      return
    }

    toast.success('초기화했습니다.')
    await loadUsers()

    setWaiting(false)
  }

  const handleChangePassword = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const { value } = e.target
    if (index === 1) {
      setClassPassword1(value.trim())
    } else if (index === 2) {
      setClassPassword2(value.trim())
    } else {
      console.log('handleChangePassword error')
    }
  }

  const handleSaveGroupPasswords = async () => {
    if (props.group === undefined) {
      return
    }

    const payload = {
      groupId: props.group.id.toString(),
      classPassword1: classPassword1,
      classPassword2: classPassword2,
    }
    const result = await axiosPost('/api/user/update_group_password', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      toast.error('저장에 실패했습니다.')
      return
    }

    const newGroup = {
      ...props.group,
      classPassword1: classPassword1,
      classPassword2: classPassword2,
    } as UserGroup

    props.setGroups(
      props.groups.map((g) => (g.id === newGroup.id ? newGroup : g))
    )

    console.log('setGroups', props.groups)
    toast.success('저장했습니다.')
  }

  return (
    <Container>
      <Title>
        {props.group?.name} ({isFirstInsertMode ? '생성' : '수정'})
      </Title>
      <div>
        <Popup open={openInstructorList} setOpen={setOpenInstructorList}>
          <InstructorList
            instructors={instructors}
            onSelectInstructor={onSelectInstructor}
          ></InstructorList>
        </Popup>
        <ItemTitle>선생님 계정</ItemTitle>
        <Account>
          <input
            type="text"
            placeholder="아이디"
            value={instructor ? instructor.userid : ''}
            readOnly={true}
          />
          <input
            type="text"
            placeholder="이름"
            value={instructor ? instructor.username : ''}
            readOnly={true}
          />
          <GreenButton onClick={() => setOpenInstructorList(true)}>
            선택하기
          </GreenButton>
        </Account>
      </div>
      <div>
        <div>직업등록•심사위원 비밀번호</div>
        <Account>
          <div>직업등록 비밀번호</div>
          <input
            type="text"
            placeholder="등록계정 비밀번호"
            value={classPassword1}
            onChange={(e) => handleChangePassword(e, 1)}
          />
          <div>심사위원 비밀번호</div>
          <input
            type="text"
            placeholder="심사위원 비밀번호"
            value={classPassword2}
            onChange={(e) => handleChangePassword(e, 2)}
          />

          <GreenButton
            onClick={() => {
              if (props.group) {
                handleSaveGroupPasswords()
              }
            }}
          >
            저장
          </GreenButton>
        </Account>
      </div>
      <div>
        <StudentTitle>
          <div>학생 계정</div>
          {isFirstInsertMode || showSetting ? (
            <>
              <Setting>
                <ToolButtons></ToolButtons>
                <div>
                  <SettingTitle>인원</SettingTitle>
                  <input
                    type="text"
                    placeholder=""
                    value={createStudentCnt}
                    onChange={(e) =>
                      setCreateStudentCnt(
                        isNaN(parseInt(e.target.value))
                          ? 0
                          : parseInt(e.target.value)
                      )
                    }
                  />

                  <div>명</div>
                  <BlueButton onClick={() => createUser()}>생성</BlueButton>
                </div>
                <div>
                  <SettingTitle>아이디</SettingTitle>
                  <input
                    type="text"
                    placeholder="시작단어"
                    style={{ width: '120px' }}
                    value={startId}
                    onChange={(e) => setStartId(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="시작번호"
                    style={{ width: '80px' }}
                    value={startIdNo}
                    onChange={(e) =>
                      setStartIdNo(
                        isNaN(parseInt(e.target.value))
                          ? 0
                          : parseInt(e.target.value)
                      )
                    }
                  />
                  <BlueButton onClick={() => applyUserId()}>적용</BlueButton>
                </div>
                <div>
                  <SettingTitle>학생이름</SettingTitle>
                  <input
                    type="text"
                    placeholder="시작단어"
                    style={{ width: '120px' }}
                    value={startName}
                    onChange={(e) => setStartName(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="시작번호"
                    style={{ width: '80px' }}
                    value={startNameNo}
                    onChange={(e) =>
                      setStartNameNo(
                        isNaN(parseInt(e.target.value))
                          ? 0
                          : parseInt(e.target.value)
                      )
                    }
                  />
                  <BlueButton onClick={() => applyUsername()}>적용</BlueButton>
                </div>
                <div>
                  <SettingTitle>암호</SettingTitle>
                  <input
                    type="radio"
                    id="equalId"
                    checked={passwordType === PasswordType.EQUAL_TO_USERID}
                    onClick={() =>
                      setPasswordType(PasswordType.EQUAL_TO_USERID)
                    }
                  />{' '}
                  <label htmlFor="equalId">아이디와 동일하게</label>
                  <input
                    type="radio"
                    id="samePw"
                    checked={passwordType !== PasswordType.EQUAL_TO_USERID}
                    onClick={() => setPasswordType(PasswordType.EQUAL_PASSWORD)}
                  />{' '}
                  <label htmlFor="samePw">모두 같은 암호</label>
                  {passwordType !== PasswordType.EQUAL_TO_USERID && (
                    <input
                      type="text"
                      placeholder="공통암호"
                      style={{ width: '80px' }}
                      value={commonPassword}
                      onChange={(e) => setCommonPassword(e.target.value)}
                    />
                  )}
                  <BlueButton onClick={() => applyPassword()}>적용</BlueButton>
                </div>
              </Setting>
              <Toolbar>
                {/* <OrangeButton onClick={() => setShowSetting(false)}>
                  설정감추기
                </OrangeButton> */}
                {students.length > 0 && (
                  <TomatoButton onClick={() => handleSaveAll()}>
                    학생전체저장
                  </TomatoButton>
                )}
              </Toolbar>
            </>
          ) : (
            <Toolbar>
              <TomatoButton onClick={() => handleReset()}>Reset</TomatoButton>

              {/* {!isFirstInsertMode && (
                <OrangeButton onClick={() => setShowSetting(true)}>
                  설정보기
                </OrangeButton>
              )} */}

              <Waiting isWaiting={waiting}></Waiting>
            </Toolbar>
          )}
        </StudentTitle>
        {students.map((student, index) => (
          <Account key={index}>
            <No>{index + 1}</No>
            <input
              type="text"
              placeholder="아이디"
              value={student.userid}
              onChange={(e) => onChangeStudentUserid(e, index)}
            />
            <input
              type="text"
              placeholder="학생이름"
              value={student.username}
              onChange={(e) => onChangeStudentUsername(e, index)}
            />
            <input
              type="text"
              placeholder="비밀번호"
              value={student.plainPassword}
              onChange={(e) => onChangeStudentPassword(e, index)}
            />
            {isFirstInsertMode ? (
              <BlueButton
                style={{ width: '40px' }}
                onClick={() => {
                  deleteStudent(student.userid)
                }}
              >
                삭제
              </BlueButton>
            ) : (
              <TomatoButton
                style={{ width: '40px' }}
                onClick={() => {
                  applyUser(student.userid)
                }}
              >
                저장
              </TomatoButton>
            )}
          </Account>
        ))}
      </div>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  padding: 0 20px;
  margin-bottom: 1rem;

  input[type='text'] {
    width: 150px;
    padding: 12px;
    box-sizing: border-box;
    margin: 0 10px;
    border: 1px solid #ccc;
  }

  & > div {
    padding-bottom: 20px;

    & > div:first-child {
      padding-bottom: 10px;
    }
  }
`

const ToolButtons = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`
const Title = styled.div`
  font-size: 1.5rem;
  padding-bottom: 20px;
`

const ItemTitle = styled.div`
  font-size: 1rem;
  padding-top: 20px;
`
const StudentTitle = styled.div`
  font-size: 1rem;
  padding-top: 20px;
`

const Setting = styled.div`
  position: relative;
  padding: 20px 0 20px 20px;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  background-color: aliceblue;
  padding: 20px;
  margin: 10px 0;
  div {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    column-gap: 1px;
  }
  input[type='button'] {
    width: 50px;
  }
  input[type='text'] {
    width: 50px;
  }

  button {
    margin-top: 0;
    padding: 10px 20px;
    min-width: 20px;
    margin-left: 20px;
  }
`

const SettingTitle = styled.div`
  width: 100px;
  text-align: right;
`
const Account = styled.div`
  padding: 1px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    margin: 0 10px 0 0;
    min-width: 80px;
  }
`
const No = styled.div`
  width: 30px;
  text-align: center;
`
const Toolbar = styled.div`
  padding-left: 50px;
  padding-bottom: 10px;
  text-align: left;

  & > button {
    cursor: pointer;
  }
`

const Line = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`

export default Main
